// CacheKey 2de09779f13b824c9e46ce164fc1d320
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-JACK_HUGHSTON": {
    encounters: {
      arrival: "appointment"
    },
    patient_matching: {
      fn_ln_medicaid_id: "First Name, Last Name, Patient Number"
    }
  }
}

